module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-3-7c85855bc988df01367d900fba5e7427.png";